<template>
  <div class='MakeCardCheck'>
    <search-form size='medium' labelWidth='90px' :searchData="search.searchData" :searchForm="search.searchForm"
      :searchHandle="search.searchHandle">
    </search-form>
    <div v-if="sellDetail" class="sell-detail">
      <div class="mr20">合同编号：{{ sellDetail.contactSn }}</div>
      <div class="mr20">购买人姓名：{{ sellDetail.customerName }}</div>
      <div class="mr20">购买日期：{{ sellDetail.updateDate }}</div>
    </div>
    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList" :pager="pager" />
      </template>
    </Table>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      sellDetail: null,
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '售卡订单号：', prop: 'orderSn', placeholder: '请输入订单号' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
        ]
      },

      Table: { // 表格
        selectionHandle: (v) => this.selectionHandle(v),
        primaryBtn: {
          show: true,
          html: '退卡',
          handle: (el) => this.checkEvent(el)
        },
        selectedList: [], // 选中的list
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'stateText', label: '状态' },
          { prop: 'isBindAccount', label: '是否绑定' }
        ]
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      if (!this.search.searchData.orderSn) {
        return this.$message.error('请输入订单号')
      }
      this.pager.page = 1
      this.pager.rows = 10
      this.init()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    init () {
      this.getSellDetail()
      this.getItemList()
    },

    getItemList () { // 获取列表
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.sellCardListApi(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res?.data?.total || 0
            Table.data = (res?.data?.list || []).map((item) => ({
              ...item,
              isBindAccount: item.bindAccount ? '是' : '否',
              stateText: item.state.text,
            }))
          }
        })
    },

    getSellDetail () {
      const { search } = this
      this.$http.sellDetailApi(search.searchData.orderSn)
        .then((res) => {
          if (res.status === 200) {
            this.sellDetail = res.data
          }
        })
    },
    checkEvent (el) {
      if (this.Table.selectedList.length === 0) return
      handleCofirm('确认当前操作?', 'type').then(async () => {
        let params = {
          cardIds: this.Table.selectedList.map((item) => item.id),
          originalOrderId: this.sellDetail.id
        }
        this.$http.refundApplyApi(params)
          .then(res => {
            if (res.status === 200) {
              el.clearSelection()
              this.$message.success(res.msg)
              this.getItemList()
            }
          })
      }).catch(() => {

      })
    },

    selectionHandle (v) {
      this.Table.selectedList = v
    },


  },
  created () {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;

    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
.sell-detail {
  margin: 0 20px;
  padding: 20px;
  background-color: #fff;
  display: flex;
}
.mr20 {
  margin-right: 20px;
}
</style>
